import React, { Component } from 'react'
import { withTranslation } from 'react-i18next'
import axios from 'axios'

import Rettighet from './Rettighet.jsx'
import CollapseIcon from '../../../../images/expand copy 3.png'
import ExpandIcon from '../../../../images/collapse copy 3.png'
import PilIcon from '../../../../images//Icon_Pil-ny.png'

class RettighetList extends Component {
    state = {
        rettigheter: [],
        isRettigheterLoaded: false,
        isLoading: false,
        isOpened: false
    }

    getRettigheter = () => {
        this.setState({isLoading: true})
        axios.get(`${this.props.settings.baseUrl}api/grunnbok/rettighet/`, {
            params: {
                token: this.props.token,
                kommunenummer: this.props.kommunenummer,
                gardsnummer: this.props.gardsnummer,
                bruksnummer: this.props.bruksnummer,
                festenummer: this.props.festenummer,
                seksjonsnummer: this.props.seksjonsnummer
            }
        })
        .then(({data}) => {
            this.setState({
                rettigheter: [...this.state.rettigheter, ...data.rettigheter],
                isRettigheterLoaded: true,
                isLoading: false})
        })
      }


    toggleRettigheter = () => {
        if (!this.state.isRettigheterLoaded) {
            this.getRettigheter()
        }

        this.setState({isOpened: !this.state.isOpened})
    }

    render() {
        const { t } = this.props        
        return (
            <li>
                <div className="section-header subsection" onClick={this.toggleRettigheter}>
                    { !this.state.isLoading &&
                        <div className="icon-image"><img src={PilIcon} /></div>
                    }
                    {
                        this.state.isLoading &&
                        <span className="icon"><i className="fa fa-fw fa-spinner fa-spin"></i></span>
                    }                    
                    <span className="title">{t('rettigheter')} {this.state.isRettigheterLoaded && `(${this.state.rettigheter.length})`}</span>
                    <div className="icon-image right"><img className="collapse" src={this.state.isOpened ? CollapseIcon : ExpandIcon} /></div>                    
                </div>
                <div className={this.state.isOpened && this.state.rettigheter.length > 0 ? "" : "collapsed"}>
                    <ul>
                        { this.state.rettigheter.map((r, index) => { return (<Rettighet key={r.dokumentnummer+r.dokumentnavn} rettighet={r} isLast={index==this.state.rettigheter.length-1} onEvent={this.props.onEvent} />)}) }
                    </ul>
                </div>
            </li>
        )
    }
}

export default withTranslation('common')(RettighetList)